// export default () =>
//   import(/* webpackChunkName: 'coffee/app/mastercard/add-info' */ './AddInfo');
// 由于活动线下了,预留之前的代码
export default () => import(/* webpackChunkName: 'coffee/app/mastercard/offline' */ './Offline');
